module.exports = __webpack_public_path__ + "img/apropos_deliberation-exemple.f2be06be.jpg";